const patternsToMatch = {
  '#': { pattern: /\d/ },
  a: { pattern: /[a-z]/i },
  A: { pattern: /[a-z]/i, action: (chr) => chr.toUpperCase() },
  n: { pattern: /[a-z0-9]/i },
  N: { pattern: /[a-z0-9]/i, action: (chr) => chr.toUpperCase() },
  X: { pattern: /./ },
};

function keepValueWithinMaxBinding(value, binding) {
  const result = value.substring(0, binding.value.length);
  return result;
}

function filterValue(currentValue, binding) {
  let result = currentValue;
  let stringCharIndex = 0;

  while (stringCharIndex < result.length && stringCharIndex <= binding.value.length) {
    const currentPattern = patternsToMatch[binding.value[stringCharIndex]];
    if (currentPattern === undefined) {
      //Add mask value (mask char unknown - not in pattersToMach - means a default value like space)
      if (binding.value[stringCharIndex] !== result[stringCharIndex]) {
        result =
          result.substring(0, stringCharIndex) + binding.value[stringCharIndex] + result.substring(stringCharIndex);
      }
      //Check if char is correct pattern
    } else if (!currentPattern.pattern.test(result[stringCharIndex])) {
      result = result.substring(0, stringCharIndex) + result.substring(stringCharIndex + 1);
      stringCharIndex--;
      //Execute action if applicable
    } else if (currentPattern.action) {
      result =
        result.substring(0, stringCharIndex) +
        currentPattern.action(result[stringCharIndex]) +
        result.substring(stringCharIndex + 1);
    }

    stringCharIndex++;
  }

  result = keepValueWithinMaxBinding(result, binding);

  return result;
}

function addMaskValue(lastValue, currentValue, binding) {
  let result = currentValue;
  if (lastValue.length < result.length && patternsToMatch[binding.value[result.length]] === undefined) {
    result += binding.value[result.length];
  }

  return result;
}

function calculateSelectionStart(lastValue, currentValue, binding, currentSelectionStart) {
  if (
    lastValue.length < currentValue.length &&
    binding.value[currentSelectionStart] === currentValue[currentSelectionStart]
  ) {
    return currentSelectionStart + 1;
  }
  return currentSelectionStart;
}

export default {
  beforeMount(el, binding) {
    let lastValue = el.value;
    el.inputMask = function (event) {
      const startValue = event.target.value;
      let currentValue = keepValueWithinMaxBinding(event.target.value, binding);

      currentValue = filterValue(currentValue, binding);
      currentValue = addMaskValue(lastValue, currentValue, binding);

      const selectionStart = calculateSelectionStart(lastValue, currentValue, binding, event.target.selectionStart);

      event.target.value = currentValue;
      lastValue = currentValue;

      el.selectionStart = selectionStart;
      el.selectionEnd = selectionStart;

      if (startValue !== currentValue) {
        var evt = new Event('input', { bubbles: true, cancelable: true });
        el.dispatchEvent(evt);
      }
    };

    el.addEventListener('input', el.inputMask);
  },
  unmounted(el) {
    el.removeEventListener('input', el.inputMask);
  },
};
